import useSWR from 'swr';
import { forumUserService } from '@/api/forumUser';
import { Biz } from '@/typings/open.platform.forum_bff/namespaces/configure';
import useBiz from '@/context/useBiz';
import { reportConfig } from '@/report';

const fetchUserInfo = async (biz: Biz) => {
  const res = await forumUserService.getUserInfo({
    Uid: '',
    Biz: biz,
  });
  if (res.error) {
    throw new Error(res.message);
  }
  reportConfig({ user_unique_id: res.data.User?.Id });
  return res.data;
};

export const useUserInfo = () => {
  const biz = useBiz(state => state.biz);
  const { data, isValidating } = useSWR(`${biz}`, fetchUserInfo);
  return {
    User: data?.User,
    loading: isValidating,
    ifLogin: Boolean(data),
    ifAdmin: data?.User?.IfAdmin,
    isAdmin: data?.User?.IfAdmin,
  };
};
